module.exports = __webpack_public_path__ + "static/media/cart.e028f3c0.svg";